import { apiClient } from "../../Config/ApiClient";

export const retrieveUser = (token, data) => apiClient.get(`/users`, { headers: {'Authorization': token}, params: data});

export const createUser = (token, data) => apiClient.post(`/auth/register`, data, { headers: {'Authorization': token}});

export const retrieveUserCompany = (token) => apiClient.get(`/users/company`, { headers: {'Authorization': token}});

export const updateUser = (token, data, id) => apiClient.post(`/users/update/${id}`, data, { headers: {'Authorization': token}});

export const deleteUser = (token, id) => apiClient.post(`/users/delete/${id}`, {}, { headers: {'Authorization': token }});

export const retrieveOnlineUser = (token, data) => apiClient.get(`/users/online`, { headers: {'Authorization': token}, params: data});

export const logoutUsers = (token, id) => apiClient.get(`/user/logout`, { headers: {'Authorization': token}, params: {userId: id}});

export const retrieveUserIcsxStatistic = (token) => apiClient.get(`/user/icsx_statistic`, { headers: {'Authorization': token} });

export const retrieveUserDisplayStatistic = (token) => apiClient.get(`/user/display_statistic`, { headers: {'Authorization': token} });
